import { render, staticRenderFns } from "./index.vue?vue&type=template&id=32650bfb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=32650bfb&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32650bfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32650bfb')) {
      api.createRecord('32650bfb', component.options)
    } else {
      api.reload('32650bfb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=32650bfb&scoped=true", function () {
      api.rerender('32650bfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/billManage/billCHeck/index.vue"
export default component.exports